export default __webpack_public_path__ + "static/media/Ballroll_00154.e7dd799f.png";